import {encodeParams} from "./encode-params.ts";
import type {Encodable} from "./types.ts";

interface FormEncoded {
    body: string;
    headers: Record<string, string>;
}

/* eslint-disable no-redeclare -- this is a function overload */
/**
 * x-www-form-urlencodes given data to necessary body and content-type header.
 *
 * NOTE(emily): If you need to add extra headers to your request, you need to
 * merge in the headers manually.
 *
 * This is useful for replacing usages of `$.ajax`, which defaulted to this
 * encoding for POST data. For example,
 * ```ts
 *   $.ajax("/test", { method: "POST", data: { ... } });
 * ```
 * can be replaced with
 * ```ts
 *   khanFetch("/test", { method: "POST", ...formUrlEncode({ ... }) });
 * ```
 *
 * @param data The data to be encoded.
 * @returns An object with the encoded body and headers.
 */
export function formUrlEncode(
    data: Readonly<Record<string, Encodable | null | undefined>>,
): FormEncoded;
/**
 * x-www-form-urlencodes given data to necessary body and content-type header.
 *
 * NOTE(emily): If you need to add extra headers to your request, you need to
 * merge in the headers manually.
 *
 * This is useful for replacing usages of `$.ajax`, which defaulted to this
 * encoding for POST data. For example,
 * ```ts
 *   $.ajax("/test", { method: "POST", data: { ... } });
 * ```
 * can be replaced with
 * ```ts
 *   khanFetch("/test", { method: "POST", ...formUrlEncode({ ... }) });
 * ```
 *
 * @param data The data to be encoded.
 * @returns An object with the encoded body and headers.
 */
export function formUrlEncode(
    data: ReadonlyArray<[string, Encodable | null | undefined]>,
): FormEncoded;
/**
 * x-www-form-urlencodes given data to necessary body and content-type header.
 *
 * NOTE(emily): If you need to add extra headers to your request, you need to
 * merge in the headers manually.
 *
 * This is useful for replacing usages of `$.ajax`, which defaulted to this
 * encoding for POST data. For example,
 * ```ts
 *   $.ajax("/test", { method: "POST", data: { ... } });
 * ```
 * can be replaced with
 * ```ts
 *   khanFetch("/test", { method: "POST", ...formUrlEncode({ ... }) });
 * ```
 *
 * @param data The data to be encoded.
 * @returns An object with the encoded body and headers.
 */
export function formUrlEncode(data: any): FormEncoded {
    return {
        body: encodeParams(data),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
    };
}
/* eslint-enable no-redeclare -- this is a function overload */
